export default "__VITE_ASSET__xqpfjjOB__"